import {Injectable} from '@angular/core';
import {HttpService} from "./http.service";
import {User, UserRole, UserRoleString, UserStatus} from "../models/user";
import {Observable, switchMap, timer} from "rxjs";
import {AriaLivePoliteness, LiveAnnouncer} from "@angular/cdk/a11y";
import {StateService} from "./state.service";

import * as XLSX from '@e965/xlsx';
import {CustomModalComponent} from "../components/custom-modal/custom-modal.component";
import {CustomModalService} from "./custom-modal.service";
import {Sort} from "@angular/material/sort";
import {formatDate} from "@angular/common";
import {AbstractControl, AsyncValidatorFn, ValidationErrors} from "@angular/forms";


export interface dialogOptionalVars {
  subtitle?: string | undefined,
  cancelBtn?: boolean,
  confirmText?: string,
  cancelText?: string | undefined,
  confirmButtonColor?: string | undefined,
  cancelButtonColor?: string | undefined,
  getResponse?: boolean,
  getResponseMax?: number,
  responseReq?: boolean,
  response?: string,
  getSelectResponse?: boolean,
  selectReq?: boolean,
  selectResponse?: string,
  selectData?: string[],
  ignoreESC?: boolean,
  checkBox?: boolean,
  cbText?: string,
  width?: string,
  height?: string,
  modalIconName?: string
}

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  private readonly defaults = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890.'-)(*!~";
  private readonly def_len = 40;
  private _roleKeys : string[] = [];
  private _statusKeys : string[] = []
  private _haveClipboard : boolean = false;
  private userPrivsDone = false;

  skipLinkPath! : string;

  constructor(private readonly httpService: HttpService,
              private readonly stateService : StateService,
              private readonly modalService : CustomModalService,
              private readonly liveAnnouncer : LiveAnnouncer) {
    this._roleKeys = Object.keys(UserRole).filter(f => !isNaN(Number(f)));
    this._statusKeys = Object.keys(UserStatus).filter(f => !isNaN(Number(f)));
  }

  randomKey(lengthOfCode?: number, possible?: string) {
    if (!lengthOfCode)
      lengthOfCode = this.def_len

    if (!possible) {
      possible = this.defaults;
    }

    let text = "";
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  // init(initAll : boolean = true) {
  //   if (initAll) {
      //this.userPrivsDone = false;
      // this.httpService.Get<OrgList[]>(`/ui_api/orglist`).subscribe(response => {
      //   this.orgListSub.next(response);
      // });
      // this.httpService.Get<ModelType[]>(`/ui_api/modeltype`).subscribe(response => {
      //   this.modelTypeSub.next(response);
      //   this.setUserPrivs();
      // });
    // }
    //this.getMyModelInfo();
  // }


  get role()  {
    return UserRole;
  }

  get status() {
    return UserStatus;
  }

  get haveClipboard(): boolean {
    return this._haveClipboard;
  }

  set haveClipboard(value: boolean) {
    this._haveClipboard = value;
  }

  copy(val : string) {
    navigator.clipboard.writeText(val);
  }

  getFileName(name?: string) {
    let timeSpan = new Date().toISOString();
    let sheetName = name || "ExportSheet";
    let fileName = `${sheetName}-${timeSpan}`;
    return {
      sheetName,
      fileName
    };
  }

  exportToExcel(arr: any[], name?: string, columns?: string[], colName?: any) {
    let finalArr = this.filterAndRenameDataByColumn(arr, columns, colName);

    let { sheetName, fileName } = this.getFileName(name);

    let wb = XLSX.utils.book_new();
    let ws = XLSX.utils.json_to_sheet(finalArr);
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }

  private filterAndRenameDataByColumn(data: any[], columns?: string[], colName?: any): any[] {
    const table : object[] = [];
    let tempRow: object;

    if (columns) {
      data.forEach(row => {
        tempRow = {};
        columns.forEach(key => {
          if (colName) {
            // @ts-ignore
            tempRow[colName[key]] = row[key];
          } else {
            // @ts-ignore
            tempRow[key] = row[key];
          }
        });
        table.push(tempRow);
      });
      return table;
    }
    return data;
  }

  displayDialogMessage(title: string, message: string, oVars?: dialogOptionalVars): Observable<any> {
    const dataOptions = {
      title: title,
      message: message,
      subtitle: oVars?.subtitle ? oVars.subtitle : undefined,
      cancelBtn: oVars?.cancelBtn ? oVars?.cancelBtn : false,
      confirmText: oVars?.confirmText ? oVars?.confirmText : 'OK',
      cancelText : oVars?.cancelText ? oVars?.cancelText : 'Cancel',
      confirmButtonColor: oVars?.confirmButtonColor ? oVars?.confirmButtonColor : 'primary',
      cancelButtonColor: oVars?.cancelButtonColor ? oVars?.cancelButtonColor : undefined,
      getResponse: oVars?.getResponse ? oVars?.getResponse : false,
      getResponseMax: oVars?.getResponseMax ? oVars?.getResponseMax : 0,
      responseReq: oVars?.responseReq ? oVars?.responseReq : false,
      response: oVars?.response ? oVars.response : '',
      getSelectResponse: oVars?.getSelectResponse ? oVars?.getSelectResponse : false,
      selectReq: oVars?.selectReq ? oVars?.selectReq : false,
      selectResponse: oVars?.selectResponse ? oVars.selectResponse : '',
      selectData: oVars?.selectData ? oVars.selectData : '',
      ignoreESC: oVars?.ignoreESC ? oVars?.ignoreESC : false,
      checkBox: oVars?.checkBox ? oVars?.checkBox : false,
      cbText: oVars?.cbText ? oVars?.cbText : '',
      modalIconName: oVars?.modalIconName ? oVars?.modalIconName : undefined
    };
    const config = {
      data: dataOptions,
      disableClose: true,
      width: oVars?.width ? oVars?.width : '480px',
      height: oVars?.height ? oVars?.height : 'auto'
    };

    this.modalService.open(CustomModalComponent, config);
    return this.modalService.confirmed();
  }

  liveAnnounce(message : string, politeness?: AriaLivePoliteness): Promise<void> {
    return this.liveAnnouncer.announce(message, politeness);
  }

  announceSortChange(sortState: Sort): Promise<void> {
    if (sortState.direction) {
      return this.liveAnnounce("Sorted " + sortState.direction + "ending");
    } else {
      return this.liveAnnounce("Sorting cleared");
    }
  }

  checkROB() : boolean {
    return this.stateService.loginResponse?.dto.isROBRequired;
  }

  displayROB() {
    const options = { 'responseType': 'text' as 'json' };
    this.httpService.GetRaw<any>('assets/html/rob.html', options)
      .subscribe(response => {
        // console.log(response)
        this.displayDialogMessage("Rules Of Behavior",
          response, {subtitle:"Please read and accept",
            confirmText:"ACCEPT", ignoreESC:true, width:"95%", height:"95%", checkBox:true, cbText:"Check to accept the ROB"})
          .subscribe(res => {
            if (res) {
              const form = new FormData();
              form.append("email", window.btoa(this.stateService.user.email));
              this.httpService.Post<User>('/user/rulesOfBehavior', form)
                .subscribe(response => {
                  // console.log(response)
                  this.stateService.loginResponse.dto.isROBRequired = false;
                });
              // if both ROB and the pop-up need to be displayed, ROB needs to double-check if popup needs to display
              if (this.checkPopup()) {
                this.displayPopup();
              }
            }
          });
      });
  }

  async digestMessage(message:string) {
    const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
    const hashBuffer = await crypto.subtle.digest("SHA-512", msgUint8); // hash the message
    const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
    const hashHex = hashArray
      .map((b) => b.toString(16).padStart(2, "0"))
      .join(""); // convert bytes to hex string
    return hashHex;
  }

  sortingDataAccessor<T>(row:T, columnName:string) : string {
    switch (columnName) {
      case 'submission_Date':
        return formatDate(row[columnName as keyof T] as string,'yyyyMMddHHmmss', 'en-US');
      case 'due_Date':
        return formatDate(row[columnName as keyof T] as string,'yyyyMMdd', 'en-US');
      case 'transient_Time':
        return formatDate(row['originalSubmissionDate' as keyof T] as string,'yyyyMMddHHmmss', 'en-US');
      default:
        return row[columnName as keyof T] as string;
    }
  }

  checkPopup() : boolean {
    return this.stateService.loginResponse?.displayPopup;
  }

  displayPopup() {
    this.displayDialogMessage("Notice",
      this.stateService.loginResponse.popupHtml, {ignoreESC:true, width:"95%"})
      .subscribe(res => {
        if (res) {
          this.stateService.loginResponse.displayPopup = false;
        }
      });

  }

  toSentenceCase(value: string): string {
    return (value.length === 1) ? value.charAt(0).toUpperCase() : (value.charAt(0).toUpperCase() + value.substring(1).toLowerCase());
  }

  toCamelCase(value: string): string {
    return value && value.split(/[\-_\s]+/g)
      .filter(word => !!word)
      .map((word, index) => {
        return index === 0 ? word.toLowerCase() : this.toSentenceCase(word);
      })
      .join('');
  }

  getBaseURL() {
    // Calls to back end to return a document to display does not work with angular-cli. Needs to use jboss directly
    return (window.location.origin.indexOf('4200') > 0) ? 'http://localhost:8080' : '';
  }

  getDashboardURL() {
    return '/' + UserRoleString[this.stateService.user.role_id] + '/dashboard';
  }

  removeCurlyQuotes(text: string) : string {
    // check for curly quotes and replace with regular
    if (!text) return text;
    return text.replace(/[\u2018\u2019]/g, "'").replace(/[\u201c\u201d]/g, '"');
  }

  debouncedValidator(debounceTimeMs: number, validationFn: (control: AbstractControl) => Observable<ValidationErrors | null>): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return timer(debounceTimeMs).pipe(
        switchMap(() => validationFn(control))
      );
    };
  }

  isGAOUserWithFullAccess(viewOnly: boolean, role?:UserRole) : boolean {
    if (!role) role = this.stateService.userRole;
    const isGAOUserSupervisorOrAttorney = role === UserRole.GAO_Supervisor || role === UserRole.GAO_Attorney;
    return role === UserRole.GAO_Admin || (isGAOUserSupervisorOrAttorney && !viewOnly);
  }

  base64UrlEncode(email:string): string {
    const base64string = btoa(email);

    const base64Url = base64string
      .replace(/\+/g,'-')
      .replace(/\//g,'_')
      .replace(/=+$/,'')

    return base64Url;
  }
}
